import { Component, Input } from "@angular/core";

interface DataNode {
  name: string;
  children?: DataNode[];
  value?: number;
}

@Component({
  selector: "app-nav-node",
  templateUrl: "./nav-node.component.html",
  standalone: false,
  styles: [
    `
      .nav-node-row {
        display: flex;
        align-items: center;
        padding: 7px 12px;
        cursor: pointer;
        border-bottom: 1px solid #f3f4f6;
        transition: background 0.15s;
        gap: 8px;
      }
      .nav-node-row:hover {
        background: #f8faff;
      }
      .nav-node-toggle {
        width: 18px;
        flex-shrink: 0;
        color: #9ca3af;
        font-size: 11px;
      }
      .nav-node-name {
        flex: 1;
        font-size: 13px;
        color: #374151;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
      }
      .nav-node-visits {
        width: 52px;
        text-align: right;
        font-size: 12px;
        font-weight: 600;
        color: #374151;
        flex-shrink: 0;
      }
      .nav-node-bar-wrap {
        width: 120px;
        height: 8px;
        background: #f1f5f9;
        border-radius: 4px;
        overflow: hidden;
        flex-shrink: 0;
      }
      .nav-node-bar-fill {
        display: block;
        height: 100%;
        border-radius: 4px;
        transition: width 0.3s ease;
      }
    `,
  ],
})
export class NavNodeComponent {
  @Input() node: DataNode;
  @Input() depth: number = 0;
  @Input() maxVisits: number = 1;

  expanded = false;

  readonly depthColors = [
    "#6366f1",
    "#06b6d4",
    "#10b981",
    "#f59e0b",
    "#ef4444",
  ];

  get hasChildren(): boolean {
    return !!(this.node?.children?.length);
  }

  get visits(): number {
    return this.sumVisits(this.node);
  }

  get barColor(): string {
    return this.depthColors[this.depth % this.depthColors.length];
  }

  get barWidth(): string {
    const pct =
      this.maxVisits > 0 ? (this.visits / this.maxVisits) * 100 : 0;
    return Math.min(pct, 100) + "%";
  }

  get indent(): string {
    return this.depth * 20 + "px";
  }

  toggle() {
    if (this.hasChildren) {
      this.expanded = !this.expanded;
    }
  }

  private sumVisits(node: DataNode): number {
    if (!node) return 0;
    if (!node.children || !node.children.length) return node.value || 0;
    return node.children.reduce((acc, c) => acc + this.sumVisits(c), 0);
  }
}
